module.exports = __webpack_public_path__ + "static/media/eyes.58ccd86c.png";